import { render, staticRenderFns } from "./magnifier.vue?vue&type=template&id=e4ed96ba&scoped=true&"
import script from "./magnifier.vue?vue&type=script&lang=js&"
export * from "./magnifier.vue?vue&type=script&lang=js&"
import style0 from "./magnifier.vue?vue&type=style&index=0&id=e4ed96ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ed96ba",
  null
  
)

export default component.exports